import { render } from "./TeamContentPublish.vue?vue&type=template&id=22e7366c&scoped=true&ts=true"
import script from "./TeamContentPublish.vue?vue&type=script&lang=ts"
export * from "./TeamContentPublish.vue?vue&type=script&lang=ts"

import "./TeamContentPublish.vue?vue&type=style&index=0&id=22e7366c&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/ecpv-pipeline/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e7366c"]])

export default __exports__